<template>
  <div>
    <iframe :src="pdfUrl" style="width: 100%;" height="600"></iframe>
  </div>
</template>
<script>
export default {
  name: "PDF Viewer",
  props: {
    file: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    pdfUrl: "",
  }),
  mounted() {
    this.loadPdf();
  },
  methods: {
    loadPdf() {
      const pdfData = atob(this.file.file || this.file.bytes);
      const arrayBuffer = new ArrayBuffer(pdfData.length);
      const uint8Array = new Uint8Array(arrayBuffer);

      for (let i = 0; i < pdfData.length; i++) {
        uint8Array[i] = pdfData.charCodeAt(i);
      }

      const blob = new Blob([uint8Array], { type: "application/pdf" });

      this.pdfUrl = URL.createObjectURL(blob);
    },
  },
  watch: {
    file: "loadPdf"
  }
};
</script>
